import { createContext, PropsWithChildren, useContext, useEffect } from 'react';
import Medusa from '@medusajs/js-sdk';
import get from 'lodash.get';
import { APP_SETTINGS } from '@football-kids/shared/settings';
import { supabase } from '@football-kids/client-lib/context/SupabaseContext';

const MedusaContext = createContext<Medusa>(null as unknown as Medusa);

const sdk = new Medusa({
    baseUrl: get(APP_SETTINGS, 'medusa.apiUrl'),
    publishableKey: get(APP_SETTINGS, 'medusa.apiPublishableKey'),
    auth: {
    // jwtTokenStorageKey
        type: "jwt"
    }
});

export const MedusaContextProvider = ({ children }: PropsWithChildren) => {
    return <MedusaContext.Provider value={sdk}>
        {children}
    </MedusaContext.Provider>;
};

export const useMedusaContext = () => {


    return useContext(MedusaContext);
};
